module.exports = __webpack_public_path__ + "static/media/ally_pro_6.45d897d1.jpg";